/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_DownloadInputs */

const es_billing_invoices_download = /** @type {(inputs: Billing_Invoices_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar factura`)
};

const en_billing_invoices_download = /** @type {(inputs: Billing_Invoices_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download invoice`)
};

/**
* | output |
* | --- |
* | "Download invoice" |
*
* @param {Billing_Invoices_DownloadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_invoices_download = /** @type {((inputs?: Billing_Invoices_DownloadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_DownloadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_invoices_download(inputs)
	return en_billing_invoices_download(inputs)
});
export { billing_invoices_download as "billing.invoices.download" }